var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"operator-wrapper",on:{"click":_vm.tableClickAction}},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"operator-button",attrs:{"attr-id":item.id}},[_vm._v(_vm._s(item.label))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }